document.addEventListener('DOMContentLoaded', () => {
  const toggleBtn = document.querySelector('.details-toggle');
  const labelExpand = toggleBtn.querySelector('.label-expand');
  const labelCollapse = toggleBtn.querySelector('.label-collapse');
  const allLists = document.querySelectorAll('.details-list');
  let expanded = false;

  // start collapsed
  allLists.forEach(list => {
    list.classList.add('is-collapsed');
    list.style.maxHeight = '20px';
  });

  toggleBtn.addEventListener('click', () => {
    expanded = !expanded;

    labelExpand.style.display = expanded ? 'none' : '';
    labelCollapse.style.display = expanded ? '' : 'none';

    allLists.forEach(list => {
      if (expanded) {
        list.classList.remove('is-collapsed');
        list.style.maxHeight = list.scrollHeight + 'px';
      } else {
        list.classList.add('is-collapsed');
        list.style.maxHeight = '20px';
      }
    });
  });
});